import buttons     from './buttons';
import textFields  from './text-fields';
import datepicker  from './datepicker';
import icons       from './icons';
import tabs        from './tabs';
import accordions  from './accordions';
import dialogs     from './dialogs';
import paginations from './paginations';
import progresses  from './progresses';
import loadings    from './loadings';
import downloader  from './downloader';
import banners     from './banners';
import select      from './select';
import transitions from './transitions';
import navigations from './navigations';
import notices     from './notices';
import statics     from './statics';
import advanced    from './advanced';



export default Object.assign({},
  buttons,
  textFields,
  datepicker,
  icons,
  tabs,
  accordions,
  dialogs,
  paginations,
  downloader,
  progresses,
  loadings,
  banners,
  select,
  transitions,
  navigations,
  notices,
  statics,
  advanced,
);



// WEBPACK FOOTER //
// ./src/js/ui/components/_index.js